import _classCallCheck from "/builds/martinmende/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/martinmende/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _taggedTemplateLiteral from "/builds/martinmende/website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34;

import React from 'react';
import styled, { css, keyframes, createGlobalStyle, ThemeProvider } from 'styled-components';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var colorName = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};

var isArrayish = function isArrayish(obj) {
  if (!obj || typeof obj === 'string') {
    return false;
  }

  return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};

var simpleSwizzle = createCommonjsModule(function (module) {
  var concat = Array.prototype.concat;
  var slice = Array.prototype.slice;

  var swizzle = module.exports = function swizzle(args) {
    var results = [];

    for (var i = 0, len = args.length; i < len; i++) {
      var arg = args[i];

      if (isArrayish(arg)) {
        // http://jsperf.com/javascript-array-concat-vs-push/98
        results = concat.call(results, slice.call(arg));
      } else {
        results.push(arg);
      }
    }

    return results;
  };

  swizzle.wrap = function (fn) {
    return function () {
      return fn(swizzle(arguments));
    };
  };
});
var colorString = createCommonjsModule(function (module) {
  /* MIT license */
  var reverseNames = {}; // create a list of reverse color names

  for (var name in colorName) {
    if (colorName.hasOwnProperty(name)) {
      reverseNames[colorName[name]] = name;
    }
  }

  var cs = module.exports = {
    to: {},
    get: {}
  };

  cs.get = function (string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;

    switch (prefix) {
      case 'hsl':
        val = cs.get.hsl(string);
        model = 'hsl';
        break;

      case 'hwb':
        val = cs.get.hwb(string);
        model = 'hwb';
        break;

      default:
        val = cs.get.rgb(string);
        model = 'rgb';
        break;
    }

    if (!val) {
      return null;
    }

    return {
      model: model,
      value: val
    };
  };

  cs.get.rgb = function (string) {
    if (!string) {
      return null;
    }

    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var keyword = /(\D+)/;
    var rgb = [0, 0, 0, 1];
    var match;
    var i;
    var hexAlpha;

    if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];

      for (i = 0; i < 3; i++) {
        // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
        var i2 = i * 2;
        rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
      }

      if (hexAlpha) {
        rgb[3] = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
      }
    } else if (match = string.match(abbr)) {
      match = match[1];
      hexAlpha = match[3];

      for (i = 0; i < 3; i++) {
        rgb[i] = parseInt(match[i] + match[i], 16);
      }

      if (hexAlpha) {
        rgb[3] = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
      }
    } else if (match = string.match(rgba)) {
      for (i = 0; i < 3; i++) {
        rgb[i] = parseInt(match[i + 1], 0);
      }

      if (match[4]) {
        rgb[3] = parseFloat(match[4]);
      }
    } else if (match = string.match(per)) {
      for (i = 0; i < 3; i++) {
        rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }

      if (match[4]) {
        rgb[3] = parseFloat(match[4]);
      }
    } else if (match = string.match(keyword)) {
      if (match[1] === 'transparent') {
        return [0, 0, 0, 0];
      }

      rgb = colorName[match[1]];

      if (!rgb) {
        return null;
      }

      rgb[3] = 1;
      return rgb;
    } else {
      return null;
    }

    for (i = 0; i < 3; i++) {
      rgb[i] = clamp(rgb[i], 0, 255);
    }

    rgb[3] = clamp(rgb[3], 0, 1);
    return rgb;
  };

  cs.get.hsl = function (string) {
    if (!string) {
      return null;
    }

    var hsl = /^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string.match(hsl);

    if (match) {
      var alpha = parseFloat(match[4]);
      var h = (parseFloat(match[1]) + 360) % 360;
      var s = clamp(parseFloat(match[2]), 0, 100);
      var l = clamp(parseFloat(match[3]), 0, 100);
      var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
    }

    return null;
  };

  cs.get.hwb = function (string) {
    if (!string) {
      return null;
    }

    var hwb = /^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/;
    var match = string.match(hwb);

    if (match) {
      var alpha = parseFloat(match[4]);
      var h = (parseFloat(match[1]) % 360 + 360) % 360;
      var w = clamp(parseFloat(match[2]), 0, 100);
      var b = clamp(parseFloat(match[3]), 0, 100);
      var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
    }

    return null;
  };

  cs.to.hex = function () {
    var rgba = simpleSwizzle(arguments);
    return '#' + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (rgba[3] < 1 ? hexDouble(Math.round(rgba[3] * 255)) : '');
  };

  cs.to.rgb = function () {
    var rgba = simpleSwizzle(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
  };

  cs.to.rgb.percent = function () {
    var rgba = simpleSwizzle(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
  };

  cs.to.hsl = function () {
    var hsla = simpleSwizzle(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
  }; // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
  // (hwb have alpha optional & 1 is default value)


  cs.to.hwb = function () {
    var hwba = simpleSwizzle(arguments);
    var a = '';

    if (hwba.length >= 4 && hwba[3] !== 1) {
      a = ', ' + hwba[3];
    }

    return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
  };

  cs.to.keyword = function (rgb) {
    return reverseNames[rgb.slice(0, 3)];
  }; // helpers


  function clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
  }

  function hexDouble(num) {
    var str = num.toString(16).toUpperCase();
    return str.length < 2 ? '0' + str : str;
  }
});
var colorString_1 = colorString.to;
var colorString_2 = colorString.get;
var colorName$1 = {
  "aliceblue": [240, 248, 255],
  "antiquewhite": [250, 235, 215],
  "aqua": [0, 255, 255],
  "aquamarine": [127, 255, 212],
  "azure": [240, 255, 255],
  "beige": [245, 245, 220],
  "bisque": [255, 228, 196],
  "black": [0, 0, 0],
  "blanchedalmond": [255, 235, 205],
  "blue": [0, 0, 255],
  "blueviolet": [138, 43, 226],
  "brown": [165, 42, 42],
  "burlywood": [222, 184, 135],
  "cadetblue": [95, 158, 160],
  "chartreuse": [127, 255, 0],
  "chocolate": [210, 105, 30],
  "coral": [255, 127, 80],
  "cornflowerblue": [100, 149, 237],
  "cornsilk": [255, 248, 220],
  "crimson": [220, 20, 60],
  "cyan": [0, 255, 255],
  "darkblue": [0, 0, 139],
  "darkcyan": [0, 139, 139],
  "darkgoldenrod": [184, 134, 11],
  "darkgray": [169, 169, 169],
  "darkgreen": [0, 100, 0],
  "darkgrey": [169, 169, 169],
  "darkkhaki": [189, 183, 107],
  "darkmagenta": [139, 0, 139],
  "darkolivegreen": [85, 107, 47],
  "darkorange": [255, 140, 0],
  "darkorchid": [153, 50, 204],
  "darkred": [139, 0, 0],
  "darksalmon": [233, 150, 122],
  "darkseagreen": [143, 188, 143],
  "darkslateblue": [72, 61, 139],
  "darkslategray": [47, 79, 79],
  "darkslategrey": [47, 79, 79],
  "darkturquoise": [0, 206, 209],
  "darkviolet": [148, 0, 211],
  "deeppink": [255, 20, 147],
  "deepskyblue": [0, 191, 255],
  "dimgray": [105, 105, 105],
  "dimgrey": [105, 105, 105],
  "dodgerblue": [30, 144, 255],
  "firebrick": [178, 34, 34],
  "floralwhite": [255, 250, 240],
  "forestgreen": [34, 139, 34],
  "fuchsia": [255, 0, 255],
  "gainsboro": [220, 220, 220],
  "ghostwhite": [248, 248, 255],
  "gold": [255, 215, 0],
  "goldenrod": [218, 165, 32],
  "gray": [128, 128, 128],
  "green": [0, 128, 0],
  "greenyellow": [173, 255, 47],
  "grey": [128, 128, 128],
  "honeydew": [240, 255, 240],
  "hotpink": [255, 105, 180],
  "indianred": [205, 92, 92],
  "indigo": [75, 0, 130],
  "ivory": [255, 255, 240],
  "khaki": [240, 230, 140],
  "lavender": [230, 230, 250],
  "lavenderblush": [255, 240, 245],
  "lawngreen": [124, 252, 0],
  "lemonchiffon": [255, 250, 205],
  "lightblue": [173, 216, 230],
  "lightcoral": [240, 128, 128],
  "lightcyan": [224, 255, 255],
  "lightgoldenrodyellow": [250, 250, 210],
  "lightgray": [211, 211, 211],
  "lightgreen": [144, 238, 144],
  "lightgrey": [211, 211, 211],
  "lightpink": [255, 182, 193],
  "lightsalmon": [255, 160, 122],
  "lightseagreen": [32, 178, 170],
  "lightskyblue": [135, 206, 250],
  "lightslategray": [119, 136, 153],
  "lightslategrey": [119, 136, 153],
  "lightsteelblue": [176, 196, 222],
  "lightyellow": [255, 255, 224],
  "lime": [0, 255, 0],
  "limegreen": [50, 205, 50],
  "linen": [250, 240, 230],
  "magenta": [255, 0, 255],
  "maroon": [128, 0, 0],
  "mediumaquamarine": [102, 205, 170],
  "mediumblue": [0, 0, 205],
  "mediumorchid": [186, 85, 211],
  "mediumpurple": [147, 112, 219],
  "mediumseagreen": [60, 179, 113],
  "mediumslateblue": [123, 104, 238],
  "mediumspringgreen": [0, 250, 154],
  "mediumturquoise": [72, 209, 204],
  "mediumvioletred": [199, 21, 133],
  "midnightblue": [25, 25, 112],
  "mintcream": [245, 255, 250],
  "mistyrose": [255, 228, 225],
  "moccasin": [255, 228, 181],
  "navajowhite": [255, 222, 173],
  "navy": [0, 0, 128],
  "oldlace": [253, 245, 230],
  "olive": [128, 128, 0],
  "olivedrab": [107, 142, 35],
  "orange": [255, 165, 0],
  "orangered": [255, 69, 0],
  "orchid": [218, 112, 214],
  "palegoldenrod": [238, 232, 170],
  "palegreen": [152, 251, 152],
  "paleturquoise": [175, 238, 238],
  "palevioletred": [219, 112, 147],
  "papayawhip": [255, 239, 213],
  "peachpuff": [255, 218, 185],
  "peru": [205, 133, 63],
  "pink": [255, 192, 203],
  "plum": [221, 160, 221],
  "powderblue": [176, 224, 230],
  "purple": [128, 0, 128],
  "rebeccapurple": [102, 51, 153],
  "red": [255, 0, 0],
  "rosybrown": [188, 143, 143],
  "royalblue": [65, 105, 225],
  "saddlebrown": [139, 69, 19],
  "salmon": [250, 128, 114],
  "sandybrown": [244, 164, 96],
  "seagreen": [46, 139, 87],
  "seashell": [255, 245, 238],
  "sienna": [160, 82, 45],
  "silver": [192, 192, 192],
  "skyblue": [135, 206, 235],
  "slateblue": [106, 90, 205],
  "slategray": [112, 128, 144],
  "slategrey": [112, 128, 144],
  "snow": [255, 250, 250],
  "springgreen": [0, 255, 127],
  "steelblue": [70, 130, 180],
  "tan": [210, 180, 140],
  "teal": [0, 128, 128],
  "thistle": [216, 191, 216],
  "tomato": [255, 99, 71],
  "turquoise": [64, 224, 208],
  "violet": [238, 130, 238],
  "wheat": [245, 222, 179],
  "white": [255, 255, 255],
  "whitesmoke": [245, 245, 245],
  "yellow": [255, 255, 0],
  "yellowgreen": [154, 205, 50]
};
var conversions = createCommonjsModule(function (module) {
  /* MIT license */
  // NOTE: conversions should only return primitive values (i.e. arrays, or
  //       values that give correct `typeof` results).
  //       do not use box values types (i.e. Number(), String(), etc.)
  var reverseKeywords = {};

  for (var key in colorName$1) {
    if (colorName$1.hasOwnProperty(key)) {
      reverseKeywords[colorName$1[key]] = key;
    }
  }

  var convert = module.exports = {
    rgb: {
      channels: 3,
      labels: 'rgb'
    },
    hsl: {
      channels: 3,
      labels: 'hsl'
    },
    hsv: {
      channels: 3,
      labels: 'hsv'
    },
    hwb: {
      channels: 3,
      labels: 'hwb'
    },
    cmyk: {
      channels: 4,
      labels: 'cmyk'
    },
    xyz: {
      channels: 3,
      labels: 'xyz'
    },
    lab: {
      channels: 3,
      labels: 'lab'
    },
    lch: {
      channels: 3,
      labels: 'lch'
    },
    hex: {
      channels: 1,
      labels: ['hex']
    },
    keyword: {
      channels: 1,
      labels: ['keyword']
    },
    ansi16: {
      channels: 1,
      labels: ['ansi16']
    },
    ansi256: {
      channels: 1,
      labels: ['ansi256']
    },
    hcg: {
      channels: 3,
      labels: ['h', 'c', 'g']
    },
    apple: {
      channels: 3,
      labels: ['r16', 'g16', 'b16']
    },
    gray: {
      channels: 1,
      labels: ['gray']
    }
  }; // hide .channels and .labels properties

  for (var model in convert) {
    if (convert.hasOwnProperty(model)) {
      if (!('channels' in convert[model])) {
        throw new Error('missing channels property: ' + model);
      }

      if (!('labels' in convert[model])) {
        throw new Error('missing channel labels property: ' + model);
      }

      if (convert[model].labels.length !== convert[model].channels) {
        throw new Error('channel and label counts mismatch: ' + model);
      }

      var channels = convert[model].channels;
      var labels = convert[model].labels;
      delete convert[model].channels;
      delete convert[model].labels;
      Object.defineProperty(convert[model], 'channels', {
        value: channels
      });
      Object.defineProperty(convert[model], 'labels', {
        value: labels
      });
    }
  }

  convert.rgb.hsl = function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;

    if (max === min) {
      h = 0;
    } else if (r === max) {
      h = (g - b) / delta;
    } else if (g === max) {
      h = 2 + (b - r) / delta;
    } else if (b === max) {
      h = 4 + (r - g) / delta;
    }

    h = Math.min(h * 60, 360);

    if (h < 0) {
      h += 360;
    }

    l = (min + max) / 2;

    if (max === min) {
      s = 0;
    } else if (l <= 0.5) {
      s = delta / (max + min);
    } else {
      s = delta / (2 - max - min);
    }

    return [h, s * 100, l * 100];
  };

  convert.rgb.hsv = function (rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);

    var diffc = function diffc(c) {
      return (v - c) / 6 / diff + 1 / 2;
    };

    if (diff === 0) {
      h = s = 0;
    } else {
      s = diff / v;
      rdif = diffc(r);
      gdif = diffc(g);
      bdif = diffc(b);

      if (r === v) {
        h = bdif - gdif;
      } else if (g === v) {
        h = 1 / 3 + rdif - bdif;
      } else if (b === v) {
        h = 2 / 3 + gdif - rdif;
      }

      if (h < 0) {
        h += 1;
      } else if (h > 1) {
        h -= 1;
      }
    }

    return [h * 360, s * 100, v * 100];
  };

  convert.rgb.hwb = function (rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [h, w * 100, b * 100];
  };

  convert.rgb.cmyk = function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [c * 100, m * 100, y * 100, k * 100];
  };
  /**
   * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
   * */


  function comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
  }

  convert.rgb.keyword = function (rgb) {
    var reversed = reverseKeywords[rgb];

    if (reversed) {
      return reversed;
    }

    var currentClosestDistance = Infinity;
    var currentClosestKeyword;

    for (var keyword in colorName$1) {
      if (colorName$1.hasOwnProperty(keyword)) {
        var value = colorName$1[keyword]; // Compute comparative distance

        var distance = comparativeDistance(rgb, value); // Check if its less, if so set as closest

        if (distance < currentClosestDistance) {
          currentClosestDistance = distance;
          currentClosestKeyword = keyword;
        }
      }
    }

    return currentClosestKeyword;
  };

  convert.keyword.rgb = function (keyword) {
    return colorName$1[keyword];
  };

  convert.rgb.xyz = function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255; // assume sRGB

    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [x * 100, y * 100, z * 100];
  };

  convert.rgb.lab = function (rgb) {
    var xyz = convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [l, a, b];
  };

  convert.hsl.rgb = function (hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;

    if (s === 0) {
      val = l * 255;
      return [val, val, val];
    }

    if (l < 0.5) {
      t2 = l * (1 + s);
    } else {
      t2 = l + s - l * s;
    }

    t1 = 2 * l - t2;
    rgb = [0, 0, 0];

    for (var i = 0; i < 3; i++) {
      t3 = h + 1 / 3 * -(i - 1);

      if (t3 < 0) {
        t3++;
      }

      if (t3 > 1) {
        t3--;
      }

      if (6 * t3 < 1) {
        val = t1 + (t2 - t1) * 6 * t3;
      } else if (2 * t3 < 1) {
        val = t2;
      } else if (3 * t3 < 2) {
        val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
      } else {
        val = t1;
      }

      rgb[i] = val * 255;
    }

    return rgb;
  };

  convert.hsl.hsv = function (hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [h, sv * 100, v * 100];
  };

  convert.hsv.rgb = function (hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;

    switch (hi) {
      case 0:
        return [v, t, p];

      case 1:
        return [q, v, p];

      case 2:
        return [p, v, t];

      case 3:
        return [p, q, v];

      case 4:
        return [t, p, v];

      case 5:
        return [v, p, q];
    }
  };

  convert.hsv.hsl = function (hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [h, sl * 100, l * 100];
  }; // http://dev.w3.org/csswg/css-color/#hwb-to-rgb


  convert.hwb.rgb = function (hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n; // wh + bl cant be > 1

    if (ratio > 1) {
      wh /= ratio;
      bl /= ratio;
    }

    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;

    if ((i & 0x01) !== 0) {
      f = 1 - f;
    }

    n = wh + f * (v - wh); // linear interpolation

    var r;
    var g;
    var b;

    switch (i) {
      default:
      case 6:
      case 0:
        r = v;
        g = n;
        b = wh;
        break;

      case 1:
        r = n;
        g = v;
        b = wh;
        break;

      case 2:
        r = wh;
        g = v;
        b = n;
        break;

      case 3:
        r = wh;
        g = n;
        b = v;
        break;

      case 4:
        r = n;
        g = wh;
        b = v;
        break;

      case 5:
        r = v;
        g = wh;
        b = n;
        break;
    }

    return [r * 255, g * 255, b * 255];
  };

  convert.cmyk.rgb = function (cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [r * 255, g * 255, b * 255];
  };

  convert.xyz.rgb = function (xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.2040 + z * 1.0570; // assume sRGB

    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [r * 255, g * 255, b * 255];
  };

  convert.xyz.lab = function (xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [l, a, b];
  };

  convert.lab.xyz = function (lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [x, y, z];
  };

  convert.lab.lch = function (lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;

    if (h < 0) {
      h += 360;
    }

    c = Math.sqrt(a * a + b * b);
    return [l, c, h];
  };

  convert.lch.lab = function (lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [l, a, b];
  };

  convert.rgb.ansi16 = function (args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

    value = Math.round(value / 50);

    if (value === 0) {
      return 30;
    }

    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));

    if (value === 2) {
      ansi += 60;
    }

    return ansi;
  };

  convert.hsv.ansi16 = function (args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
  };

  convert.rgb.ansi256 = function (args) {
    var r = args[0];
    var g = args[1];
    var b = args[2]; // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.

    if (r === g && g === b) {
      if (r < 8) {
        return 16;
      }

      if (r > 248) {
        return 231;
      }

      return Math.round((r - 8) / 247 * 24) + 232;
    }

    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
  };

  convert.ansi16.rgb = function (args) {
    var color = args % 10; // handle greyscale

    if (color === 0 || color === 7) {
      if (args > 50) {
        color += 3.5;
      }

      color = color / 10.5 * 255;
      return [color, color, color];
    }

    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [r, g, b];
  };

  convert.ansi256.rgb = function (args) {
    // handle greyscale
    if (args >= 232) {
      var c = (args - 232) * 10 + 8;
      return [c, c, c];
    }

    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [r, g, b];
  };

  convert.rgb.hex = function (args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
  };

  convert.hex.rgb = function (args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);

    if (!match) {
      return [0, 0, 0];
    }

    var colorString = match[0];

    if (match[0].length === 3) {
      colorString = colorString.split('').map(function (char) {
        return char + char;
      }).join('');
    }

    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [r, g, b];
  };

  convert.rgb.hcg = function (rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;

    if (chroma < 1) {
      grayscale = min / (1 - chroma);
    } else {
      grayscale = 0;
    }

    if (chroma <= 0) {
      hue = 0;
    } else if (max === r) {
      hue = (g - b) / chroma % 6;
    } else if (max === g) {
      hue = 2 + (b - r) / chroma;
    } else {
      hue = 4 + (r - g) / chroma + 4;
    }

    hue /= 6;
    hue %= 1;
    return [hue * 360, chroma * 100, grayscale * 100];
  };

  convert.hsl.hcg = function (hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;

    if (l < 0.5) {
      c = 2.0 * s * l;
    } else {
      c = 2.0 * s * (1.0 - l);
    }

    if (c < 1.0) {
      f = (l - 0.5 * c) / (1.0 - c);
    }

    return [hsl[0], c * 100, f * 100];
  };

  convert.hsv.hcg = function (hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;

    if (c < 1.0) {
      f = (v - c) / (1 - c);
    }

    return [hsv[0], c * 100, f * 100];
  };

  convert.hcg.rgb = function (hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;

    if (c === 0.0) {
      return [g * 255, g * 255, g * 255];
    }

    var pure = [0, 0, 0];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;

    switch (Math.floor(hi)) {
      case 0:
        pure[0] = 1;
        pure[1] = v;
        pure[2] = 0;
        break;

      case 1:
        pure[0] = w;
        pure[1] = 1;
        pure[2] = 0;
        break;

      case 2:
        pure[0] = 0;
        pure[1] = 1;
        pure[2] = v;
        break;

      case 3:
        pure[0] = 0;
        pure[1] = w;
        pure[2] = 1;
        break;

      case 4:
        pure[0] = v;
        pure[1] = 0;
        pure[2] = 1;
        break;

      default:
        pure[0] = 1;
        pure[1] = 0;
        pure[2] = w;
    }

    mg = (1.0 - c) * g;
    return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
  };

  convert.hcg.hsv = function (hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;

    if (v > 0.0) {
      f = c / v;
    }

    return [hcg[0], f * 100, v * 100];
  };

  convert.hcg.hsl = function (hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;

    if (l > 0.0 && l < 0.5) {
      s = c / (2 * l);
    } else if (l >= 0.5 && l < 1.0) {
      s = c / (2 * (1 - l));
    }

    return [hcg[0], s * 100, l * 100];
  };

  convert.hcg.hwb = function (hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [hcg[0], (v - c) * 100, (1 - v) * 100];
  };

  convert.hwb.hcg = function (hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;

    if (c < 1) {
      g = (v - c) / (1 - c);
    }

    return [hwb[0], c * 100, g * 100];
  };

  convert.apple.rgb = function (apple) {
    return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
  };

  convert.rgb.apple = function (rgb) {
    return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
  };

  convert.gray.rgb = function (args) {
    return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
  };

  convert.gray.hsl = convert.gray.hsv = function (args) {
    return [0, 0, args[0]];
  };

  convert.gray.hwb = function (gray) {
    return [0, 100, gray[0]];
  };

  convert.gray.cmyk = function (gray) {
    return [0, 0, 0, gray[0]];
  };

  convert.gray.lab = function (gray) {
    return [gray[0], 0, 0];
  };

  convert.gray.hex = function (gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
  };

  convert.rgb.gray = function (rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [val / 255 * 100];
  };
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;
/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
  var graph = {}; // https://jsperf.com/object-keys-vs-for-in-with-closure/3

  var models = Object.keys(conversions);

  for (var len = models.length, i = 0; i < len; i++) {
    graph[models[i]] = {
      // http://jsperf.com/1-vs-infinity
      // micro-opt, but this is simple.
      distance: -1,
      parent: null
    };
  }

  return graph;
} // https://en.wikipedia.org/wiki/Breadth-first_search


function deriveBFS(fromModel) {
  var graph = buildGraph();
  var queue = [fromModel]; // unshift -> queue -> pop

  graph[fromModel].distance = 0;

  while (queue.length) {
    var current = queue.pop();
    var adjacents = Object.keys(conversions[current]);

    for (var len = adjacents.length, i = 0; i < len; i++) {
      var adjacent = adjacents[i];
      var node = graph[adjacent];

      if (node.distance === -1) {
        node.distance = graph[current].distance + 1;
        node.parent = current;
        queue.unshift(adjacent);
      }
    }
  }

  return graph;
}

function link(from, to) {
  return function (args) {
    return to(from(args));
  };
}

function wrapConversion(toModel, graph) {
  var path = [graph[toModel].parent, toModel];
  var fn = conversions[graph[toModel].parent][toModel];
  var cur = graph[toModel].parent;

  while (graph[cur].parent) {
    path.unshift(graph[cur].parent);
    fn = link(conversions[graph[cur].parent][cur], fn);
    cur = graph[cur].parent;
  }

  fn.conversion = path;
  return fn;
}

var route = function route(fromModel) {
  var graph = deriveBFS(fromModel);
  var conversion = {};
  var models = Object.keys(graph);

  for (var len = models.length, i = 0; i < len; i++) {
    var toModel = models[i];
    var node = graph[toModel];

    if (node.parent === null) {
      // no possible conversion, or this node is the source model.
      continue;
    }

    conversion[toModel] = wrapConversion(toModel, graph);
  }

  return conversion;
};

var convert = {};
var models = Object.keys(conversions);

function wrapRaw(fn) {
  var wrappedFn = function wrappedFn(args) {
    if (args === undefined || args === null) {
      return args;
    }

    if (arguments.length > 1) {
      args = Array.prototype.slice.call(arguments);
    }

    return fn(args);
  }; // preserve .conversion property if there is one


  if ('conversion' in fn) {
    wrappedFn.conversion = fn.conversion;
  }

  return wrappedFn;
}

function wrapRounded(fn) {
  var wrappedFn = function wrappedFn(args) {
    if (args === undefined || args === null) {
      return args;
    }

    if (arguments.length > 1) {
      args = Array.prototype.slice.call(arguments);
    }

    var result = fn(args); // we're assuming the result is an array here.
    // see notice in conversions.js; don't use box types
    // in conversion functions.

    if (typeof result === 'object') {
      for (var len = result.length, i = 0; i < len; i++) {
        result[i] = Math.round(result[i]);
      }
    }

    return result;
  }; // preserve .conversion property if there is one


  if ('conversion' in fn) {
    wrappedFn.conversion = fn.conversion;
  }

  return wrappedFn;
}

models.forEach(function (fromModel) {
  convert[fromModel] = {};
  Object.defineProperty(convert[fromModel], 'channels', {
    value: conversions[fromModel].channels
  });
  Object.defineProperty(convert[fromModel], 'labels', {
    value: conversions[fromModel].labels
  });
  var routes = route(fromModel);
  var routeModels = Object.keys(routes);
  routeModels.forEach(function (toModel) {
    var fn = routes[toModel];
    convert[fromModel][toModel] = wrapRounded(fn);
    convert[fromModel][toModel].raw = wrapRaw(fn);
  });
});
var colorConvert = convert;
var _slice = [].slice;
var skippedModels = [// to be honest, I don't really feel like keyword belongs in color convert, but eh.
'keyword', // gray conflicts with some method names, and has its own method defined.
'gray', // shouldn't really be in color-convert either...
'hex'];
var hashedModelKeys = {};
Object.keys(colorConvert).forEach(function (model) {
  hashedModelKeys[_slice.call(colorConvert[model].labels).sort().join('')] = model;
});
var limiters = {};

function Color(obj, model) {
  if (!(this instanceof Color)) {
    return new Color(obj, model);
  }

  if (model && model in skippedModels) {
    model = null;
  }

  if (model && !(model in colorConvert)) {
    throw new Error('Unknown model: ' + model);
  }

  var i;
  var channels;

  if (obj == null) {
    // eslint-disable-line no-eq-null,eqeqeq
    this.model = 'rgb';
    this.color = [0, 0, 0];
    this.valpha = 1;
  } else if (obj instanceof Color) {
    this.model = obj.model;
    this.color = obj.color.slice();
    this.valpha = obj.valpha;
  } else if (typeof obj === 'string') {
    var result = colorString.get(obj);

    if (result === null) {
      throw new Error('Unable to parse color from string: ' + obj);
    }

    this.model = result.model;
    channels = colorConvert[this.model].channels;
    this.color = result.value.slice(0, channels);
    this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
  } else if (obj.length) {
    this.model = model || 'rgb';
    channels = colorConvert[this.model].channels;

    var newArr = _slice.call(obj, 0, channels);

    this.color = zeroArray(newArr, channels);
    this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
  } else if (typeof obj === 'number') {
    // this is always RGB - can be converted later on.
    obj &= 0xFFFFFF;
    this.model = 'rgb';
    this.color = [obj >> 16 & 0xFF, obj >> 8 & 0xFF, obj & 0xFF];
    this.valpha = 1;
  } else {
    this.valpha = 1;
    var keys = Object.keys(obj);

    if ('alpha' in obj) {
      keys.splice(keys.indexOf('alpha'), 1);
      this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
    }

    var hashedKeys = keys.sort().join('');

    if (!(hashedKeys in hashedModelKeys)) {
      throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
    }

    this.model = hashedModelKeys[hashedKeys];
    var labels = colorConvert[this.model].labels;
    var color = [];

    for (i = 0; i < labels.length; i++) {
      color.push(obj[labels[i]]);
    }

    this.color = zeroArray(color);
  } // perform limitations (clamping, etc.)


  if (limiters[this.model]) {
    channels = colorConvert[this.model].channels;

    for (i = 0; i < channels; i++) {
      var limit = limiters[this.model][i];

      if (limit) {
        this.color[i] = limit(this.color[i]);
      }
    }
  }

  this.valpha = Math.max(0, Math.min(1, this.valpha));

  if (Object.freeze) {
    Object.freeze(this);
  }
}

Color.prototype = {
  toString: function toString() {
    return this.string();
  },
  toJSON: function toJSON() {
    return this[this.model]();
  },
  string: function string(places) {
    var self = this.model in colorString.to ? this : this.rgb();
    self = self.round(typeof places === 'number' ? places : 1);
    var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
    return colorString.to[self.model](args);
  },
  percentString: function percentString(places) {
    var self = this.rgb().round(typeof places === 'number' ? places : 1);
    var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
    return colorString.to.rgb.percent(args);
  },
  array: function array() {
    return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
  },
  object: function object() {
    var result = {};
    var channels = colorConvert[this.model].channels;
    var labels = colorConvert[this.model].labels;

    for (var i = 0; i < channels; i++) {
      result[labels[i]] = this.color[i];
    }

    if (this.valpha !== 1) {
      result.alpha = this.valpha;
    }

    return result;
  },
  unitArray: function unitArray() {
    var rgb = this.rgb().color;
    rgb[0] /= 255;
    rgb[1] /= 255;
    rgb[2] /= 255;

    if (this.valpha !== 1) {
      rgb.push(this.valpha);
    }

    return rgb;
  },
  unitObject: function unitObject() {
    var rgb = this.rgb().object();
    rgb.r /= 255;
    rgb.g /= 255;
    rgb.b /= 255;

    if (this.valpha !== 1) {
      rgb.alpha = this.valpha;
    }

    return rgb;
  },
  round: function round(places) {
    places = Math.max(places || 0, 0);
    return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
  },
  alpha: function alpha(val) {
    if (arguments.length) {
      return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
    }

    return this.valpha;
  },
  // rgb
  red: getset('rgb', 0, maxfn(255)),
  green: getset('rgb', 1, maxfn(255)),
  blue: getset('rgb', 2, maxfn(255)),
  hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) {
    return (val % 360 + 360) % 360;
  }),
  // eslint-disable-line brace-style
  saturationl: getset('hsl', 1, maxfn(100)),
  lightness: getset('hsl', 2, maxfn(100)),
  saturationv: getset('hsv', 1, maxfn(100)),
  value: getset('hsv', 2, maxfn(100)),
  chroma: getset('hcg', 1, maxfn(100)),
  gray: getset('hcg', 2, maxfn(100)),
  white: getset('hwb', 1, maxfn(100)),
  wblack: getset('hwb', 2, maxfn(100)),
  cyan: getset('cmyk', 0, maxfn(100)),
  magenta: getset('cmyk', 1, maxfn(100)),
  yellow: getset('cmyk', 2, maxfn(100)),
  black: getset('cmyk', 3, maxfn(100)),
  x: getset('xyz', 0, maxfn(100)),
  y: getset('xyz', 1, maxfn(100)),
  z: getset('xyz', 2, maxfn(100)),
  l: getset('lab', 0, maxfn(100)),
  a: getset('lab', 1),
  b: getset('lab', 2),
  keyword: function keyword(val) {
    if (arguments.length) {
      return new Color(val);
    }

    return colorConvert[this.model].keyword(this.color);
  },
  hex: function hex(val) {
    if (arguments.length) {
      return new Color(val);
    }

    return colorString.to.hex(this.rgb().round().color);
  },
  rgbNumber: function rgbNumber() {
    var rgb = this.rgb().color;
    return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
  },
  luminosity: function luminosity() {
    // http://www.w3.org/TR/WCAG20/#relativeluminancedef
    var rgb = this.rgb().color;
    var lum = [];

    for (var i = 0; i < rgb.length; i++) {
      var chan = rgb[i] / 255;
      lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
    }

    return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
  },
  contrast: function contrast(color2) {
    // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
    var lum1 = this.luminosity();
    var lum2 = color2.luminosity();

    if (lum1 > lum2) {
      return (lum1 + 0.05) / (lum2 + 0.05);
    }

    return (lum2 + 0.05) / (lum1 + 0.05);
  },
  level: function level(color2) {
    var contrastRatio = this.contrast(color2);

    if (contrastRatio >= 7.1) {
      return 'AAA';
    }

    return contrastRatio >= 4.5 ? 'AA' : '';
  },
  isDark: function isDark() {
    // YIQ equation from http://24ways.org/2010/calculating-color-contrast
    var rgb = this.rgb().color;
    var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
    return yiq < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  negate: function negate() {
    var rgb = this.rgb();

    for (var i = 0; i < 3; i++) {
      rgb.color[i] = 255 - rgb.color[i];
    }

    return rgb;
  },
  lighten: function lighten(ratio) {
    var hsl = this.hsl();
    hsl.color[2] += hsl.color[2] * ratio;
    return hsl;
  },
  darken: function darken(ratio) {
    var hsl = this.hsl();
    hsl.color[2] -= hsl.color[2] * ratio;
    return hsl;
  },
  saturate: function saturate(ratio) {
    var hsl = this.hsl();
    hsl.color[1] += hsl.color[1] * ratio;
    return hsl;
  },
  desaturate: function desaturate(ratio) {
    var hsl = this.hsl();
    hsl.color[1] -= hsl.color[1] * ratio;
    return hsl;
  },
  whiten: function whiten(ratio) {
    var hwb = this.hwb();
    hwb.color[1] += hwb.color[1] * ratio;
    return hwb;
  },
  blacken: function blacken(ratio) {
    var hwb = this.hwb();
    hwb.color[2] += hwb.color[2] * ratio;
    return hwb;
  },
  grayscale: function grayscale() {
    // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
    var rgb = this.rgb().color;
    var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
    return Color.rgb(val, val, val);
  },
  fade: function fade(ratio) {
    return this.alpha(this.valpha - this.valpha * ratio);
  },
  opaquer: function opaquer(ratio) {
    return this.alpha(this.valpha + this.valpha * ratio);
  },
  rotate: function rotate(degrees) {
    var hsl = this.hsl();
    var hue = hsl.color[0];
    hue = (hue + degrees) % 360;
    hue = hue < 0 ? 360 + hue : hue;
    hsl.color[0] = hue;
    return hsl;
  },
  mix: function mix(mixinColor, weight) {
    // ported from sass implementation in C
    // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
    if (!mixinColor || !mixinColor.rgb) {
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
    }

    var color1 = mixinColor.rgb();
    var color2 = this.rgb();
    var p = weight === undefined ? 0.5 : weight;
    var w = 2 * p - 1;
    var a = color1.alpha() - color2.alpha();
    var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
    var w2 = 1 - w1;
    return Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
  }
}; // model conversion methods and static constructors

Object.keys(colorConvert).forEach(function (model) {
  if (skippedModels.indexOf(model) !== -1) {
    return;
  }

  var channels = colorConvert[model].channels; // conversion methods

  Color.prototype[model] = function () {
    if (this.model === model) {
      return new Color(this);
    }

    if (arguments.length) {
      return new Color(arguments, model);
    }

    var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
    return new Color(assertArray(colorConvert[this.model][model].raw(this.color)).concat(newAlpha), model);
  }; // 'static' construction methods


  Color[model] = function (color) {
    if (typeof color === 'number') {
      color = zeroArray(_slice.call(arguments), channels);
    }

    return new Color(color, model);
  };
});

function roundTo(num, places) {
  return Number(num.toFixed(places));
}

function roundToPlace(places) {
  return function (num) {
    return roundTo(num, places);
  };
}

function getset(model, channel, modifier) {
  model = Array.isArray(model) ? model : [model];
  model.forEach(function (m) {
    (limiters[m] || (limiters[m] = []))[channel] = modifier;
  });
  model = model[0];
  return function (val) {
    var result;

    if (arguments.length) {
      if (modifier) {
        val = modifier(val);
      }

      result = this[model]();
      result.color[channel] = val;
      return result;
    }

    result = this[model]().color[channel];

    if (modifier) {
      result = modifier(result);
    }

    return result;
  };
}

function maxfn(max) {
  return function (v) {
    return Math.max(0, Math.min(max, v));
  };
}

function assertArray(val) {
  return Array.isArray(val) ? val : [val];
}

function zeroArray(arr, length) {
  for (var i = 0; i < length; i++) {
    if (typeof arr[i] !== 'number') {
      arr[i] = 0;
    }
  }

  return arr;
}

var color = Color;
var mightyBlue = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition: background-position 0.25s linear;\n  background: linear-gradient(\n    60deg,\n    ", " -30%,\n    ", " 120%\n  );\n"])), function (props) {
  return props.theme.ac.colors.gradientStart;
}, function (props) {
  return props.theme.ac.colors.gradientStop;
});
var gradientCss = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 3em;\n    height: 100%;\n    box-sizing: border-box;\n    background: rgba(255, 255, 255, 0.3);\n    transform-origin: center;\n    transform: translateX(-120px) rotate(45deg) scaleY(3) translateY(25%);\n    transform-origin: bottom;\n    transition: transform 0.5s ease-out, opacity 0.5s ease-out;\n    pointer-events: none;\n  }\n  &:hover:not([disabled]) {\n    &:after {\n      transform: translateX(120px) rotate(45deg) scaleY(3) translateY(25%);\n      opacity: 0;\n    }\n  }\n"])));
var Button = styled.button.attrs(function (props) {
  var theme = props.theme,
      _props$color = props.color,
      color$1 = _props$color === void 0 ? 'none' : _props$color,
      outline = props.outline,
      _props$size = props.size,
      size = _props$size === void 0 ? 'regular' : _props$size;
  var baseColor = theme.ac.colors.light;

  if (color$1 === 'gradient') {
    baseColor = theme.ac.colors.primary;
  }

  if (color$1 !== 'none' && color$1 !== 'gradient') {
    baseColor = theme.ac.colors[color$1];
  }

  var padding = "".concat(Math.pow(props.theme.ac.scale, -4), "em ").concat(Math.pow(props.theme.ac.scale, -1), "em");
  var fontSize = '1em';

  if (size === 'small') {
    fontSize = "".concat(Math.pow(props.theme.ac.scale, -1), "em");
    padding = "".concat(Math.pow(props.theme.ac.scale, -10), "em ").concat(Math.pow(props.theme.ac.scale, -3), "em");
  } else if (size === 'large') {
    fontSize = "".concat(props.theme.ac.scale, "em");
    padding = "".concat(Math.pow(props.theme.ac.scale, -2), "em ").concat(Math.pow(props.theme.ac.scale, -0.5), "em");
  }

  var c = color(baseColor);
  var colorShade;

  switch (color$1) {
    case 'secondary':
      colorShade = c.fade(0.5);
      break;

    case 'info':
    case 'warning':
      colorShade = c.lighten(0.2);
      break;

    case 'none':
      colorShade = color(theme.ac.colors.grey);
      break;

    default:
      colorShade = c.lighten(0.3);
  }

  return Object.assign(Object.assign({}, props), {
    color: color$1,
    baseColor: baseColor,
    colorShade: colorShade.toString(),
    className: outline ? 'outline' : '',
    fontSize: fontSize,
    padding: padding
  });
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: 1.65;\n  text-transform: uppercase;\n  text-decoration: none;\n  letter-spacing: 1px;\n  padding: ", ";\n  background: ", ";\n  ", "\n  color: ", ";\n  border-radius: ", ";\n  border: 0;\n  cursor: pointer;\n  transition: box-shadow 0.2s ease-out;\n  transition: 0.3s;\n  position: relative;\n  overflow: hidden;\n  ", "\n\n  &.outline {\n    background: transparent;\n    color: ", ";\n    border: solid 2px ", ";\n    padding: calc(", "em - 2px) calc(", "em - 2px);\n    transition: box-shadow .2s ease-out, background .1s linear, color .25s linear;\n    ", "\n    &:after {\n      display: none;\n    }\n  }\n  &:focus {\n    outline: 0;\n    box-shadow: 0 0 0 4px ", ";\n  }\n  &:disabled {\n    background: ", ";\n    cursor: not-allowed;\n    ", "\n    &.outline {\n      background: ", ";\n      color: ", ";\n      border: solid 2px ", ";\n    }\n  }\n  &:hover:not([disabled]) {\n    // box-shadow: 0 6px 6px -6px #333;\n    box-shadow: ", ";\n    &:focus {\n      box-shadow: 0 0 0 4px ", ", ", ";\n    }\n    &.outline {\n      background: ", ";\n      color: ", ";\n      ", "\n      ", "\n    }\n  }\n  ", "\n"])), function (props) {
  return props.theme.ac.font.family;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.baseColor;
}, function (props) {
  return props.color === 'gradient' ? mightyBlue : '';
}, function (props) {
  return props.theme.ac.colors.light;
}, function (props) {
  return props.theme.ac.borderRadius.toString();
}, function (props) {
  return props.color === 'none' ? css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          color: ", ";\n          border: solid 1px ", ";\n        "])), props.theme.ac.colors.dark, props.theme.ac.colors.grey) : '';
}, function (props) {
  return props.baseColor;
}, function (props) {
  return props.baseColor;
}, function (props) {
  return Math.pow(props.theme.ac.scale, -4);
}, function (props) {
  return Math.pow(props.theme.ac.scale, -1);
}, function (props) {
  return props.color === 'none' ? css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            color: ", ";\n            border: solid 2px ", ";\n          "])), props.theme.ac.colors.dark, props.theme.ac.colors.dark) : '';
}, function (props) {
  return props.colorShade;
}, function (props) {
  return props.colorShade;
}, function (props) {
  return props.color === 'none' ? css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            border: solid 1px ", ";\n            background: ", ";\n            color: ", ";\n          "])), props.theme.ac.colors.grey, props.theme.ac.colors.light, props.theme.ac.colors.grey) : '';
}, function (props) {
  return props.theme.ac.colors.light;
}, function (props) {
  return props.colorShade;
}, function (props) {
  return props.colorShade;
}, function (props) {
  return props.theme.ac.shadows.short;
}, function (props) {
  return props.colorShade;
}, function (props) {
  return props.theme.ac.shadows.short;
}, function (props) {
  return props.baseColor;
}, function (props) {
  return props.theme.ac.colors.light;
}, function (props) {
  return props.color === 'gradient' ? mightyBlue : '';
}, function (props) {
  return props.color === 'none' ? css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n              background: ", ";\n            "])), props.theme.ac.colors.dark) : '';
}, function (props) {
  return props.color === 'gradient' ? gradientCss : '';
});
/**
 * Filters props being used by the Button component so that they
 * won't be added to the DOM element itself
 * @param Component The component to use
 */

var filterButtonProps = function filterButtonProps(Component) {
  return function (_a) {
    var props = __rest(_a, ["theme", "color", "baseColor", "outline", "colorShade"]);

    return React.createElement(Component, Object.assign({}, props));
  };
};

var InterruptedRotate = keyframes(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(45deg);\n  }\n  95% {\n    transform: rotate(405deg);\n  }\n  100% {\n    transform: rotate(405deg);\n  }\n"])));
var ContinuousRotate = keyframes(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(45deg);\n  }\n  100% {\n    transform: rotate(405deg);\n  }\n"])));
var CircleLoader = styled.div.attrs(function (props) {
  var _props$continuous = props.continuous,
      continuous = _props$continuous === void 0 ? false : _props$continuous;
  return Object.assign(Object.assign({}, props), {
    continuous: continuous
  });
})(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: inline-block;\n  border-radius: 50%;\n  width: 1em;\n  height: 1em;\n  border: solid 2px ", ";\n  border-top-color: transparent;\n  border-bottom-color: transparent;\n  animation: ", ";\n  animation-duration: ", ";\n  animation-iteration-count: infinite;\n  animation-timing-function: ", ";\n"])), function (props) {
  return props.theme.ac.colors.primary;
}, function (props) {
  return props.continuous ? ContinuousRotate : InterruptedRotate;
}, function (props) {
  return props.continuous ? '0.6s' : '.8s';
}, function (props) {
  return props.continuous ? 'linear' : 'ease-in-out';
});
var Stack = styled.section(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  & > * + * {\n    ", ";\n  }\n"])), function (props) {
  return props.horizontal ? 'row' : 'column';
}, function (props) {
  return !props.space ? '' : props.horizontal ? css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n            margin-left: 1.5rem;\n          "]))) : css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n            margin-top: 1.5rem;\n          "])));
});
var ItemWrapper = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  margin: 5px;\n  order: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n  ", "\n"])), function (props) {
  return props.order;
}, function (props) {
  return props.grow;
}, function (props) {
  return props.shrink;
}, function (props) {
  return props.basis;
}, function (props) {
  return props.align ? "align-self: ".concat(props.align, ";") : '';
});

var Item = function Item(_ref) {
  var children = _ref.children,
      _ref$order = _ref.order,
      order = _ref$order === void 0 ? 0 : _ref$order,
      _ref$grow = _ref.grow,
      grow = _ref$grow === void 0 ? 0 : _ref$grow,
      _ref$shrink = _ref.shrink,
      shrink = _ref$shrink === void 0 ? 1 : _ref$shrink,
      _ref$basis = _ref.basis,
      basis = _ref$basis === void 0 ? 'auto' : _ref$basis,
      align = _ref.align,
      style = _ref.style;
  return React.createElement(ItemWrapper, {
    order: order,
    grow: grow,
    shrink: shrink,
    basis: basis,
    style: style,
    align: align
  }, children);
};

Item.defaultProps = {
  order: 0,
  grow: 0,
  shrink: 1,
  basis: 'auto'
};
var BoxWrapper = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 5px;\n  flex-wrap: ", ";\n  flex-direction: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  align-content: ", ";\n"])), function (props) {
  return props.wrap;
}, function (props) {
  return props.direction;
}, function (props) {
  return props.justify;
}, function (props) {
  return props.align;
}, function (props) {
  return props.alignContent;
});

var Flexbox = function Flexbox(_ref2) {
  var children = _ref2.children,
      _ref2$wrap = _ref2.wrap,
      wrap = _ref2$wrap === void 0 ? 'nowrap' : _ref2$wrap,
      _ref2$direction = _ref2.direction,
      direction = _ref2$direction === void 0 ? 'row' : _ref2$direction,
      _ref2$justify = _ref2.justify,
      justify = _ref2$justify === void 0 ? 'flex-start' : _ref2$justify,
      _ref2$align = _ref2.align,
      align = _ref2$align === void 0 ? 'stretch' : _ref2$align,
      _ref2$alignContent = _ref2.alignContent,
      alignContent = _ref2$alignContent === void 0 ? 'stretch' : _ref2$alignContent,
      style = _ref2.style;
  return React.createElement(BoxWrapper, {
    style: style,
    wrap: wrap,
    direction: direction,
    justify: justify,
    align: align,
    alignContent: alignContent
  }, children);
};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */


var INFINITY = 1 / 0;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal || freeSelf || Function('return this')();
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to generate unique IDs. */

var idCounter = 0;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */

var objectToString = objectProto.toString;
/** Built-in value references. */

var Symbol = root.Symbol;
/** Used to convert symbols to primitives and strings. */

var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */


function isObjectLike(value) {
  return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */


function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */


function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

var lodash_uniqueid = uniqueId;
var Wrapper = styled.svg(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: visible;\n  .mask {\n    fill: white;\n    stroke: white;\n    stroke-width: 2px;\n    transform: scale(0);\n    transition: transform 0.25s linear;\n    &:nth-child(2) {\n      transform-origin: bottom right;\n    }\n  }\n  .border {\n    fill: transparent;\n    stroke: ", ";\n    stroke-width: 2px;\n  }\n  &.valid .border {\n    stroke: ", ";\n  }\n  &.invalid .border {\n    stroke: ", ";\n  }\n"])), function (props) {
  return props.theme.ac.colors.primary;
}, function (props) {
  return props.theme.ac.colors.success;
}, function (props) {
  return props.theme.ac.colors.danger;
});

var FocusBorder = function FocusBorder(props) {
  var status = props.status;
  var maskIdRef = React.useRef(lodash_uniqueid('at-input-'));
  var maskId = maskIdRef.current;
  return React.createElement(Wrapper, {
    className: "focus-border ".concat(status ? status : ''),
    preserveAspectRatio: "none"
  }, React.createElement("mask", {
    id: maskId
  }, React.createElement("rect", {
    className: "mask",
    width: "100%",
    height: "100%"
  }), React.createElement("rect", {
    className: "mask",
    width: "100%",
    height: "100%"
  })), React.createElement("rect", {
    className: "border",
    rx: 7,
    ry: 7,
    width: "100%",
    height: "100%",
    mask: "url(#".concat(maskId, ")"),
    vectorEffect: "non-scaling-stroke"
  }));
};

var Wrapper$1 = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  margin: 1em 0;\n  overflow: visible;\n  min-width: 230px;\n  &:first-child {\n    margin-left: 0;\n  }\n  &:last-child {\n    margin-right: 0;\n  }\n"])));
var Label = styled.label(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 1em;\n  top: ", "em;\n  left: 1em;\n  color: ", ";\n  position: absolute;\n  width: 100%;\n  transition: 0.3s;\n  letter-spacing: 0.5px;\n  /* z-index: -1; */\n  pointer-events: none;\n"])), function (props) {
  return props.theme.ac.font.family;
}, function (props) {
  return Math.pow(props.theme.ac.scale, -3);
}, function (props) {
  return props.theme.ac.colors.grey;
});
var Message = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", "em;\n  color: ", ";\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: -2em;\n  white-space: nowrap;\n  transition: color 0.3s;\n"])), function (props) {
  return props.theme.ac.font.family;
}, function (props) {
  return Math.pow(props.theme.ac.scale, -1);
}, function (props) {
  return props.status === 'invalid' ? props.theme.ac.colors.danger : props.theme.ac.colors.success;
});
var LoaderWrapper = styled.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", "em;\n  right: ", "em;\n"])), function (props) {
  return Math.pow(props.theme.ac.scale, -2);
}, function (props) {
  return Math.pow(props.theme.ac.scale, -2);
});
var InputEl = styled.input(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  -webkit-appearance: none;\n  font-family: ", ";\n  font-size: 1em;\n  color: ", ";\n  width: 100%;\n  border: solid 1px ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  padding: ", "em 1em;\n  margin: 0; /* Safari fix */\n  background: transparent;\n  ::placeholder {\n    font-family: ", ";\n    font-size: 1em;\n    color: ", ";\n\n    transition: opacity 0.3s;\n  }\n  &[disabled] {\n    cursor: not-allowed;\n    background: rgba(0, 0, 0, 0.05);\n    color: ", ";\n  }\n  &.loading {\n    padding-right: 40px;\n  }\n  /* When not empty leave the label on top */\n  &:not([value='']) /*, :placeholder-shown*/ {\n    & ~ ", " {\n      top: -2em;\n      left: 0;\n      font-size: 0.8em;\n      color: ", ";\n    }\n  }\n  &.has-label:not(:focus)[value='']::placeholder {\n    opacity: 0;\n  }\n  :focus,\n  &.valid,\n  &.invalid {\n    outline: none;\n    & ~ ", " {\n      top: -2em;\n      left: 0;\n      font-size: ", "em;\n      color: ", ";\n    }\n    & ~ .focus-border .mask {\n      transform: scale(1);\n    }\n  }\n  &:not(:focus).invalid ~ ", " {\n    color: ", ";\n  }\n  &:not(:focus).valid ~ ", " {\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.ac.font.family;
}, function (props) {
  return props.theme.ac.colors.dark;
}, function (props) {
  return props.theme.ac.colors.grey;
}, function (props) {
  return props.theme.ac.borderRadius.toString();
}, function (props) {
  return Math.pow(props.theme.ac.scale, -2);
}, function (props) {
  return props.theme.ac.font.family;
}, function (props) {
  return props.theme.ac.colors.grey;
}, function (props) {
  return props.theme.ac.colors.grey;
}, Label, function (props) {
  return props.theme.ac.colors.grey;
}, Label, function (props) {
  return Math.pow(props.theme.ac.scale, -1);
}, function (props) {
  return props.theme.ac.colors.primary;
}, Label, function (props) {
  return props.theme.ac.colors.danger;
}, Label, function (props) {
  return props.theme.ac.colors.success;
});

var Input = function Input(props) {
  var label = props.label,
      status = props.status,
      statusMessage = props.statusMessage,
      id = props.id,
      className = props.className,
      style = props.style,
      ref = props.ref,
      inputRef = props.inputRef,
      inputProps = __rest(props, ["label", "status", "statusMessage", "id", "className", "style", "ref", "inputRef"]);

  var inputId = React.useRef(lodash_uniqueid('at-input-'));
  return React.createElement(Wrapper$1, {
    id: id,
    className: className,
    style: style,
    ref: ref
  }, React.createElement(InputEl, Object.assign({
    id: inputId.current,
    className: "".concat(status, " ").concat(label ? 'has-label' : ''),
    "aria-invalid": status === 'invalid',
    ref: inputRef
  }, inputProps)), label && React.createElement(Label, {
    htmlFor: inputId.current
  }, label), React.createElement(FocusBorder, {
    status: status
  }), status !== 'loading' && React.createElement(Message, {
    status: status,
    role: status === 'invalid' ? 'alert' : undefined
  }, statusMessage), status === 'loading' && React.createElement(LoaderWrapper, null, React.createElement(CircleLoader, {
    continuous: true
  })));
};

var Wrapper$2 = styled.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  label {\n    display: inline-flex;\n    cursor: pointer;\n  }\n  .check {\n    position: relative;\n    top: 3px;\n    width: 18px;\n    height: 18px;\n    -webkit-tap-highlight-color: transparent;\n    transform: translate3d(0, 0, 0);\n    &:before {\n      content: '';\n      position: absolute;\n      top: -15px;\n      left: -15px;\n      width: 48px;\n      height: 48px;\n      border-radius: 50%;\n      background: rgba(", ", 0.03);\n      opacity: 0;\n      transition: opacity 0.2s ease;\n    }\n    svg {\n      position: relative;\n      z-index: 1;\n      fill: none;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      stroke: ", ";\n      stroke-width: 1px;\n      transform: translate3d(0, 0, 0);\n      transition: all 0.2s ease;\n      path {\n        stroke-dasharray: 60;\n        stroke-dashoffset: 0;\n      }\n      polyline {\n        stroke-dasharray: 22;\n        stroke-dashoffset: 66;\n      }\n    }\n    &:hover {\n      &:before {\n        opacity: 1;\n      }\n      svg {\n        stroke: ", ";\n      }\n    }\n  }\n  input[type='checkbox']:checked + label .check {\n    svg {\n      stroke: ", ";\n      stroke-width: 2px;\n      path {\n        stroke-dashoffset: 60;\n        transition: all 0.3s linear;\n      }\n      polyline {\n        stroke-dashoffset: 42;\n        transition: all 0.2s linear;\n        transition-delay: 0.15s;\n      }\n    }\n  }\n  input[type='checkbox'][disabled] + label {\n    cursor: not-allowed;\n    .check {\n      svg {\n        stroke: ", ";\n      }\n    }\n  }\n  input[type='checkbox'][disabled]:not(:checked) + label .check:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: ", ";\n    opacity: 0.3;\n    border-radius: 3px;\n  }\n  &:focus {\n    outline: none;\n    input[type='checkbox']:not([disabled]) + label .check svg {\n      stroke: ", ";\n    }\n    svg {\n      stroke-width: 2px;\n    }\n  }\n"])), function (props) {
  return props.theme.ac.colors.primary;
}, function (props) {
  return props.theme.ac.colors.grey;
}, function (props) {
  return props.theme.ac.colors.primary;
}, function (props) {
  return props.theme.ac.colors.primary;
}, function (props) {
  return props.theme.ac.colors.grey;
}, function (props) {
  return props.theme.ac.colors.grey;
}, function (props) {
  return props.theme.ac.colors.primary;
});
var LabelText = styled.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-family: ", ";\n  font-size: 1em;\n  padding-left: 0.5em;\n  line-height: 1.65;\n"])), function (props) {
  return props.theme.ac.font.family;
});

var Checkbox = function Checkbox(props) {
  var checked = props.checked,
      onChange = props.onChange,
      text = props.label,
      disabled = props.disabled;
  var inputIdRef = React.useRef(lodash_uniqueid('at-input-'));
  var inputId = inputIdRef.current;
  return React.createElement(Wrapper$2, {
    role: "checkbox",
    "aria-checked": checked,
    "aria-disabled": disabled,
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      if (!disabled && onChange && (e.which === 32 || e.key === 'Enter')) {
        e.preventDefault();
        onChange();
      }
    }
  }, React.createElement("input", {
    type: "checkbox",
    id: inputId,
    style: {
      display: 'none'
    },
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }), React.createElement("label", {
    htmlFor: inputId
  }, React.createElement("div", {
    className: "check"
  }, React.createElement("svg", {
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18"
  }, React.createElement("path", {
    d: "M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"
  }), React.createElement("polyline", {
    points: "1 9 7 14 15 4"
  }))), React.createElement(LabelText, null, text)));
};

var Wrapper$3 = styled.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  position: relative;\n  margin: 1em 0;\n  /* Resize handle */\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    pointer-events: none;\n    width: 0;\n    height: 1em;\n    border-left: 2px solid ", ";\n    transform: translateY(-1px) translateX(-0.5em) rotate(45deg);\n    transform-origin: center;\n    opacity: 0.5;\n    // cursor: row-resize; // does not work for pointer-events: none;\n  }\n"])), function (props) {
  return props.theme.ac.colors.grey;
});
var Label$1 = styled.label(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 1em;\n  color: ", ";\n  position: absolute;\n  width: 100%;\n  top: ", "em;\n  left: 1em;\n  transition: 0.3s;\n  letter-spacing: 0.5px;\n  /* z-index: -1; */\n  pointer-events: none;\n"])), function (props) {
  return props.theme.ac.font.family;
}, function (props) {
  return props.theme.ac.colors.grey;
}, function (props) {
  return Math.pow(props.theme.ac.scale, -3);
});
var TextAreaEl = styled.textarea(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  display: block;\n  font-family: ", ";\n  font-size: 1em;\n  color: ", ";\n  width: 100%;\n  height: 100%;\n  min-height: 6em;\n  border: solid 1px ", ";\n  border-radius: ", ";\n  padding: ", "em 1em;\n  box-sizing: border-box;\n  resize: vertical;\n  background: transparent;\n  ::placeholder {\n    font-family: ", ";\n    font-size: 1em;\n    color: ", ";\n\n    transition: opacity 0.3s;\n  }\n  ::-webkit-resizer {\n    /* webkit seems to use the opacity from ::placeholder herefore as well */\n    display: none;\n  }\n  &[disabled] {\n    cursor: not-allowed;\n    background: rgba(0, 0, 0, 0.05);\n    color: ", ";\n  }\n  /* When not empty leave the label on top */\n  &:not(:empty) /*, :placeholder-shown*/ {\n    & ~ ", " {\n      top: -2em;\n      left: 0;\n      font-size: 0.8em;\n      color: ", ";\n    }\n  }\n  &.has-label:not(:focus):empty::placeholder {\n    opacity: 0;\n  }\n  :focus,\n  &.valid,\n  &.invalid {\n    outline: none;\n    & ~ ", " {\n      top: -2em;\n      left: 0;\n      font-size: ", "em;\n      color: ", ";\n    }\n    & ~ .focus-border .mask {\n      transform: scale(1);\n    }\n  }\n"])), function (props) {
  return props.theme.ac.font.family;
}, function (props) {
  return props.theme.ac.colors.dark;
}, function (props) {
  return props.theme.ac.colors.grey;
}, function (props) {
  return props.theme.ac.borderRadius.toString();
}, function (props) {
  return Math.pow(props.theme.ac.scale, -2);
}, function (props) {
  return props.theme.ac.font.family;
}, function (props) {
  return props.theme.ac.colors.grey;
}, function (props) {
  return props.theme.ac.colors.grey;
}, Label$1, function (props) {
  return props.theme.ac.colors.grey;
}, Label$1, function (props) {
  return Math.pow(props.theme.ac.scale, -1);
}, function (props) {
  return props.theme.ac.colors.primary;
});

var Textarea = function Textarea(props) {
  var status = props.status,
      label = props.label,
      style = props.style,
      id = props.id,
      className = props.className,
      ref = props.ref,
      textAreaRef = props.textAreaRef,
      textAreaProps = __rest(props, ["status", "label", "style", "id", "className", "ref", "textAreaRef"]);

  var textAreaId = React.useRef(lodash_uniqueid('at-textarea-'));
  return React.createElement(Wrapper$3, {
    id: id,
    className: className,
    style: style,
    ref: ref
  }, React.createElement(TextAreaEl, Object.assign({
    id: textAreaId.current,
    className: "".concat(label ? 'has-label' : '', " ").concat(status ? status : ''),
    ref: textAreaRef
  }, textAreaProps)), label && React.createElement(Label$1, {
    htmlFor: textAreaId.current
  }, label), React.createElement(FocusBorder, {
    status: status
  }));
}; // import { ReactComponent as SVG } from './icon.svg';


var DashAnimation = keyframes(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  25% {\n    opacity: 1;\n  }\n  50% {\n    stroke-dashoffset: 2000;\n  }\n  75% {\n    opacity: 1;\n  }\n  100% {\n    stroke-dashoffset: 1000;\n    opacity: 0;\n  }\n"])));
var Wrapper$4 = styled.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  svg {\n    max-width: 100%;\n    max-height: 100%;\n    .maskPath {\n      fill-rule: evenodd;\n      fill: none;\n      stroke: white;\n      stroke-width: 100;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      stroke-miterlimit: 10;\n\n      stroke-dasharray: 100;\n      animation: ", ";\n      animation-iteration-count: infinite;\n      animation-timing-function: ease-in-out;\n      animation-duration: 2s;\n      animation-direction: forwards;\n      stroke-dashoffset: 3000;\n      stroke-dasharray: 1000;\n      opacity: 0;\n    }\n    .icon {\n      fill-rule: evenodd;\n\n      fill: ", ";\n    }\n  }\n"])), DashAnimation, function (props) {
  return props.theme.ac.colors.primary;
});

var IconLoader = function IconLoader(props) {
  var style = props.style;
  return React.createElement(Wrapper$4, {
    style: style
  }, React.createElement("svg", {
    x: "0px",
    y: "0px",
    viewBox: "0 0 467 298"
  }, React.createElement("mask", {
    id: "iconPathMask"
  }, React.createElement("path", {
    className: "maskPath",
    d: "\n\tM393.8,91.3C455,121.2,458.3,250.5,356,262C221.5,251.5,287.5,62.5,181,42C73,42,32,189,50,242c26.7,29.6,64.4,38.2,141.7-20.2"
  })), React.createElement("path", {
    className: "icon",
    d: "M183.8,5.7c104.6,0,50,233.5,166.4,233.5c96.3,0,95.1-156.1,5.9-152.9l0,0\n\tc119.1-33.8,153.9,201.5-3.2,201.5c-117.2,0-85.1-204.8-171.7-204.2C69.3,84.4,3,390.2,220.4,191.8C186.8,256.2,61.9,342,19.1,242.2\n\tC-20,151.1,91.3,5.7,183.8,5.7z",
    mask: "url(#iconPathMask)"
  })));
};

var Wrapper$5 = styled.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  background: repeating-linear-gradient(\n      30.5deg,\n      rgba(0, 0, 0, 0.07),\n      rgba(0, 0, 0, 0.07) 1px,\n      rgba(0, 0, 0, 0) 1px,\n      rgba(0, 0, 0, 0) 100px\n    ),\n    repeating-linear-gradient(\n      -30.5deg,\n      rgba(0, 0, 0, 0.07),\n      rgba(0, 0, 0, 0.07) 1px,\n      rgba(0, 0, 0, 0) 1px,\n      rgba(0, 0, 0, 0) 100px\n    ),\n    linear-gradient(\n      60deg,\n      ", " 0%,\n      ", " 100%\n    );\n"])), function (props) {
  return props.theme.ac.colors.gradientStart;
}, function (props) {
  return props.theme.ac.colors.gradientStop;
});

var MightyBlue = function MightyBlue(props) {
  var children = props.children,
      style = props.style;
  return React.createElement(Wrapper$5, {
    style: style
  }, children);
};

var CSSUnit = /*#__PURE__*/function () {
  function CSSUnit(size) {
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';

    _classCallCheck(this, CSSUnit);

    this.size = size;
    this.unit = unit;
  }
  /**
   * When used inside tagged template litterals like in styled components
   * this method returns the value with it's unit
   */


  _createClass(CSSUnit, [{
    key: "toString",
    value: function toString() {
      return css(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["", "", ""])), this.size, this.unit);
    }
    /**
     * Allows using the CSSUnit object to be used in calculations
     * e.g. new CSSUnit(42, 'px') + 2 // = 44
     */

  }, {
    key: "valueOf",
    value: function valueOf() {
      return this.size;
    }
  }]);

  return CSSUnit;
}();

var importFonts = css(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  @import url('https://use.typekit.net/yws6zzl.css');\n"])));
var theme = {
  ac: {
    font: {
      import: importFonts,
      family: 'urw-din, Arial, Helvetica, sans-serif'
    },
    colors: {
      gradientStart: 'rgba(62, 62, 201, 1)',
      gradientStop: 'rgba(86, 203, 249, 1)',
      primary: '#6592e1',
      secondary: '#333',
      info: '#aab8c2',
      warning: '#ffbc64',
      danger: '#f25050',
      success: '#5dc77a',
      dark: '#333',
      light: '#fff',
      grey: '#ccc'
    },
    shadows: {
      short: "0 1px 1px rgba(0,0,0,0.11), \n      0 2px 2px rgba(0,0,0,0.11), \n      0 4px 4px rgba(0,0,0,0.11), \n      0 6px 8px rgba(0,0,0,0.11),\n      0 8px 16px rgba(0,0,0,0.11)",
      long: "0 2px 1px rgba(0,0,0,0.09), \n      0 4px 2px rgba(0,0,0,0.09), \n      0 8px 4px rgba(0,0,0,0.09), \n      0 16px 8px rgba(0,0,0,0.09),\n      0 32px 16px rgba(0,0,0,0.09)",
      dreamy: "0 1px 2px rgba(0,0,0,0.07), \n      0 2px 4px rgba(0,0,0,0.07), \n      0 4px 8px rgba(0,0,0,0.07), \n      0 8px 16px rgba(0,0,0,0.07),\n      0 16px 32px rgba(0,0,0,0.07), \n      0 32px 64px rgba(0,0,0,0.07);"
    },
    borderRadius: new CSSUnit(5.24, 'px'),
    scale: 1.2
  }
};
var GlobalStyle = createGlobalStyle(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  ", "\n  html {\n    font-size: 100%; /* =16px */\n    -ms-text-size-adjust: 100%;\n    -webkit-text-size-adjust: 100%;\n  }\n  body {\n    font-family: urw-din, sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 1.65;\n    color: ", ";\n    margin: 0;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n  p {\n    margin-bottom: 1.15rem;\n  }\n  h1, h2, h3, h4, h5 {\n    margin: 2.75rem 0 1.05rem;\n    font-family: urw-din, sans-serif;\n    font-weight: 400;\n    line-height: 1.15;\n  }\n  h1 {\n    margin-top: 0;\n    font-size: ", "em;\n  }\n  h2 {\n    font-size: ", "em;\n  }\n  h3 {\n    font-size: ", "em;\n  }\n  h4 {\n    font-size: ", "em;\n  }\n  h5 {\n    font-size: ", "em;\n  }\n  h6 {\n    font-size: 1em;\n  }\n  small, .text_small {\n    font-size: ", "em;\n  }\n"])), function (props) {
  return props.theme.ac.font.import;
}, function (props) {
  return props.theme.ac.colors.dark;
}, function (props) {
  return Math.pow(props.theme.ac.scale, 6 - 1);
}, function (props) {
  return Math.pow(props.theme.ac.scale, 6 - 2);
}, function (props) {
  return Math.pow(props.theme.ac.scale, 6 - 3);
}, function (props) {
  return Math.pow(props.theme.ac.scale, 6 - 4);
}, function (props) {
  return Math.pow(props.theme.ac.scale, 6 - 5);
}, function (props) {
  return Math.pow(props.theme.ac.scale, -1);
});

var ThemeWrapper = function ThemeWrapper(props) {
  var children = props.children;
  var theme$1 = Object.assign({}, theme, props.theme);
  return React.createElement(ThemeProvider, {
    theme: theme$1
  }, React.createElement(React.Fragment, null, children, React.createElement(GlobalStyle, null)));
};

var MoveForever = keyframes(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  0% {\n    transform: translate3d(-90px, 0, 0);\n  }\n  100% {\n    transform: translate3d(85px, 0, 0);\n  }\n"])));
var Wrapper$6 = styled.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  .waves {\n    position: relative;\n    width: 100%;\n    height: 15vh;\n    margin-bottom: -8px;\n    /*Fix for safari gap*/\n    min-height: 100px;\n    max-height: 140px;\n\n    height: 100px;\n  }\n  &.inverted .waves {\n    transform: scaleY(-1) scaleX(-1);\n  }\n\n  /* Animation */\n  .parallax > use {\n    animation: ", " 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;\n  }\n  &:not(.animated) .parallax > use {\n    animation: none;\n  }\n  .parallax > use:nth-child(1) {\n    animation-delay: -2s;\n    animation-duration: 11s;\n    transform: translate3d(-41px, 0, 0);\n  }\n  .parallax > use:nth-child(2) {\n    animation-delay: -3s;\n    animation-duration: 15s;\n\n    transform: translate3d(3px, 0, 0);\n  }\n  .parallax > use:nth-child(3) {\n    animation-delay: -4s;\n    animation-duration: 20s;\n    transform: translate3d(47px, 0, 0);\n  }\n  .parallax > use:nth-child(4) {\n    animation-delay: -5s;\n    animation-duration: 30s;\n    transform: translate3d(85px, 0, 0);\n  }\n"])), MoveForever);

var Waves = function Waves(_ref3) {
  var _ref3$animated = _ref3.animated,
      animated = _ref3$animated === void 0 ? false : _ref3$animated,
      _ref3$inverted = _ref3.inverted,
      inverted = _ref3$inverted === void 0 ? false : _ref3$inverted,
      style = _ref3.style;
  var classNames = [];

  if (animated) {
    classNames.push('animated');
  }

  if (inverted) {
    classNames.push('inverted');
  }

  return React.createElement(Wrapper$6, {
    className: classNames.join(' '),
    style: style
  }, React.createElement("svg", {
    className: "waves",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 24 150 28",
    preserveAspectRatio: "none",
    shapeRendering: "auto"
  }, React.createElement("defs", null, React.createElement("path", {
    id: "gentle-wave",
    d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
  })), React.createElement("g", {
    className: "parallax"
  }, React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: "48",
    y: "0",
    fill: "rgba(255,255,255,0.7)"
  }), React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: "48",
    y: "3",
    fill: "rgba(255,255,255,0.5)"
  }), React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: "48",
    y: "5",
    fill: "rgba(255,255,255,0.3)"
  }), React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: "48",
    y: "7",
    fill: "#fff"
  }))));
};

export { Button, Checkbox, CircleLoader, Flexbox, FocusBorder, IconLoader, Input, Item, MightyBlue, Stack, Textarea, ThemeWrapper as ThemeProvider, Waves, filterButtonProps };